import i18next from 'i18next'
import React from 'react'
import { relatedContentBlockClasses } from '../../utils/style'
import { getClassName } from '../../utils/utils'
import { RelatedContentItemLayout } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockLayout'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'
import { InviewOptions } from '../cmsPage/blocks/blocksState'
import { useInView } from '../hooks/useInView'
import { GenericPageHeader } from '../sharedLayout/pageheader'

type NewsAndEventsLayoutProps = {
  index: number
  title: string
  inview?: InviewOptions
  breadcrumbs: { title: string; url: string }[]
  items: NewsOrEvent[]
}

export const NewsAndEventsOverviewLayout = (props: NewsAndEventsLayoutProps) => {
  const { index, inview, items, breadcrumbs, title } = props
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("NewsAndEventsOverviewLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <>
      <GenericPageHeader
        kind="newsAndEventsOverview"
        breadcrumbs={breadcrumbs}
        title={title}
        intro={title == 'Nieuws en meer' && i18next.t('misc:newsOverviewIntro')}
      />

      <section
        key={`block-${index}`}
        id={`io-${index}`}
        ref={ref}
        className={getClassName(relatedContentBlockClasses, 'blockClassName', 'container') + ' ' + (inView ? getClassName(relatedContentBlockClasses, 'inviewClassName', 'inview') : '')}
      >
        <div className={getClassName(relatedContentBlockClasses, 'innerClassName', 'py-5')}>
          <div className={getClassName(relatedContentBlockClasses, 'contentClassName', '')}>
            <ul className={getClassName(relatedContentBlockClasses, 'listClassName', 'list-unstyled mb-0 row')}>
              {items.map((item, index) => (
                <RelatedContentItemLayout {...item} key={index} />
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  )
}
